import { ReactNode } from 'react';
import AppShell from '@components/layout/app-shell/app-shell.tsx';
import SideNavAdmin from '@components/layout/sidebar/side-nav-admin.tsx';
import ResponsiveSideNavAdmin from '@components/layout/responsive-side-nav-admin.tsx';
import MaintenanceBanner from '@components/layout/maintenance-banner.tsx';
import { useGetAdminSettings } from '@utils/api/admin/use-get-admin-settings.ts';

interface Props {
  layoutType?: 'main' | 'editor';
  children: ReactNode;
  disableOverflowY?: boolean;
}

export default function AdminWrapper(props: Props) {
  const { data: settingsData } = useGetAdminSettings();
  const isMaintenanceMode = settingsData?.result?.maintenance_mode === 'true';

  return (
    <AppShell
      sidebar={<SideNavAdmin />}
      mobileSidebar={(open, setOpen) => (
        <ResponsiveSideNavAdmin sidebarOpen={open} setSidebarOpen={setOpen} />
      )}
      layoutType={props.layoutType}
      disableOverflowY={props.disableOverflowY}
      banners={<MaintenanceBanner isVisible={isMaintenanceMode} />}
    >
      {props.children}
    </AppShell>
  );
}
